import { Component, HostBinding, Input } from '@angular/core';
import { Router } from '@angular/router';
import { EventService } from 'src/app/services/event.service';

@Component({
    selector: 'fuse-nav-vertical-item',
    templateUrl: './nav-vertical-item.component.html',
    styleUrls: ['./nav-vertical-item.component.scss']
})
export class FuseNavVerticalItemComponent {
    @HostBinding('class') classes = 'nav-item';
    @Input() item: any;

    constructor(public events: EventService, public router: Router) {
    }
}
